module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-policy"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'bottom'
    }
  }, [_c('RegistrationTokenButtons', {
    attrs: {
      "item": _vm.item
    },
    on: {
      "itemUpdated": function($event) {
        return _vm.$emit('itemUpdated')
      }
    }
  })], 1)], 1), _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("RT" + _vm._s(_vm.item.id))])]), _c('div', {
    staticClass: "column text-center"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Token")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.token))])]), _c('div', {
    staticClass: "column text-center"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Type")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.destination_type))])]), _c('div', {
    staticClass: "column text-center"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Destination")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.destination_name))])]), _c('div', {
    staticClass: "column text-center"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Created")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.created_at))])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fec7324e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/RegistrationToken.vue
// module id = 2588
// module chunks = 1